import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@components/Carousel/ArticleCarousel.css";

import DefaultImage from "@assets/tabla_default.webp";
import { BrightcoveVideo } from "@components/BrightcoveVideo/BrightcoveVideo";
import ArticleImage from "@components/Carousel/ArticleImage";
import { YOUTUBE_WATCH_URL } from "@elements/ArticleParagraph/Embeds/constants";
import YouTubeEmbedCustom from "@elements/ArticleParagraph/Embeds/YouTubeEmbedCustom";
import { MediaCarouselItems, MediaTypes } from "@typings/Opensearch.d";
import { useRef, useState } from "react";
import ReactSlick, { Settings } from "react-slick";

export type CarouselPropType = {
  renderItems: MediaCarouselItems;
  sectionName?: string;
};

type ReactSlickModule = typeof ReactSlick & {
  default?: typeof ReactSlick;
};
const Slider = (ReactSlick as ReactSlickModule).default ?? ReactSlick;

export default function ArticleCarousel({
  renderItems,
  sectionName,
}: CarouselPropType) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = renderItems.length;
  const [autoPlay, setAutoPlay] = useState<boolean>(true);

  // eslint-disable-next-line
  const SliderComponent: typeof Slider =
    // eslint-disable-next-line
    // @ts-expect-error
    typeof window === "undefined" ? Slider.default : Slider;

  const sliderRef = useRef<ReactSlick>(null);

  const handleVideoClick = () => {
    setAutoPlay(false);
  };

  const settings: Settings = {
    infinite: true,
    swipe: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: autoPlay,
    autoplaySpeed: 5000,
    afterChange: (current: number) => {
      setCurrentSlide(current);
    },
  };
  return (
    <>
      {renderItems.length === 1 ? (
        <>
          {renderItems[0].type === MediaTypes.IMAGE && (
            <ArticleImage
              url={renderItems[0].image?.url}
              alt={renderItems[0].id}
              sectionName={sectionName}
              caption={renderItems[0].caption}
              credit={renderItems[0].credit}
            />
          )}
          {renderItems[0].type === MediaTypes.BRIGHTCOVE_VIDEO && (
            <BrightcoveVideo
              videoId={renderItems[0].videoId}
              className="xmd:!h-[550px] xmd:max-w-[825px]"
            />
          )}
          {renderItems[0].type === MediaTypes.YOUTUBE_VIDEO && (
            <YouTubeEmbedCustom
              url={`${YOUTUBE_WATCH_URL}${renderItems[0].youtubeId}`}
              className="xmd:!h-[550px] xmd:max-w-[825px]"
            />
          )}
        </>
      ) : (
        <div className="article-carousel relative h-auto">
          <SliderComponent ref={sliderRef} {...settings}>
            {renderItems.map((item) => (
              <div key={item.id}>
                {item.type === MediaTypes.IMAGE && (
                  <ArticleImage
                    index={item.id}
                    alt={item.id}
                    url={item.image?.url ? item.image.url : DefaultImage}
                    caption={item.caption}
                    credit={item.credit}
                    sectionName={sectionName}
                    currentSlideCount={currentSlide}
                    totalSlideCount={totalSlides}
                  />
                )}
                {item.type === MediaTypes.BRIGHTCOVE_VIDEO && (
                  <div
                    onClick={handleVideoClick}
                    onKeyUp={() => {}}
                    role="button"
                    key={item.videoId}
                    tabIndex={0}
                  >
                    <BrightcoveVideo
                      videoId={item.videoId}
                      className="xmd:!h-[550px] xmd:max-w-[825px]"
                    />
                  </div>
                )}
                {item.type === MediaTypes.YOUTUBE_VIDEO && (
                  <div
                    onClick={handleVideoClick}
                    onKeyUp={() => {}}
                    role="button"
                    key={item.youtubeId}
                    tabIndex={0}
                  >
                    <YouTubeEmbedCustom
                      url={`${YOUTUBE_WATCH_URL}${item.youtubeId}`}
                      className="xmd:!h-[550px] xmd:max-w-[825px]"
                    />
                  </div>
                )}
              </div>
            ))}
          </SliderComponent>
        </div>
      )}
    </>
  );
}
